import { render } from "./Mensagens.vue?vue&type=template&id=26355887&scoped=true"
import script from "./Mensagens.vue?vue&type=script&lang=js"
export * from "./Mensagens.vue?vue&type=script&lang=js"

import "./Mensagens.vue?vue&type=style&index=0&id=26355887&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26355887"]])

export default __exports__